import React from 'react';
import { cn } from '@/lib/utils';

interface FormattedTextProps {
  text: string;
  className?: string;
  textColor?: string;
}

export function FormattedText({ text, className, textColor }: FormattedTextProps) {
  if (!text) return null;

  // Convert markdown-like syntax to HTML
  const formatText = (text: string): string => {
    return text
      // Bold: **text** -> <strong>text</strong>
      .replace(/\*\*(.*?)\*\*/g, '<strong class="inherit-color">$1</strong>')
      // Italic: *text* -> <em>text</em>
      .replace(/\*(.*?)\*/g, '<em class="inherit-color">$1</em>')
      // Links: [text](url) -> <a href="url">text</a>
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">$1</a>')
      // Line breaks
      .replace(/\n/g, '<br />');
  };

  const formattedHtml = formatText(text);

  return (
    <div 
      className={cn("prose prose-lg max-w-none [&_.inherit-color]:!text-inherit", className)}
      style={{ color: textColor }}
      dangerouslySetInnerHTML={{ __html: formattedHtml }}
    />
  );
} 